import React from "react";
import { TendenciesTemplate } from "../../Templates/TendenciesTemplate";

export const Tendencies = () => {
  return <TendenciesTemplate />;
};
